import axios from 'axios';
import config from '../config';

const emailVerification = async data => {
  const res = await axios.post(`${config.API_URL}/api/accounts/email-verification/`, data);
  return res;
};

export default emailVerification;
